import { Metamodel } from 'app/model/base/model';
import { VivaInsightsReportDataset } from 'app/model/dataset/viva-insights-report.dataset';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: 'VivaInsightsSource',
    display: [],
    tags: { datasetModel: Metamodel.modelFor(VivaInsightsReportDataset) }
})
export class VivaInsightsCopySource extends TabularCopySource {
}
